import { createFileRoute, redirect } from "@tanstack/react-router";

import { canManageHelpCenter } from "@/core/lib/access";
import { denyRouteAccess } from "@/core/lib/route-access";

export const Route = createFileRoute("/_protected/help-center/admin")({
  beforeLoad: ({ context, ...guard }) => {
    const user = context.user;
    if (!canManageHelpCenter(user)) {
      denyRouteAccess(guard, "help_center_manager");
    }

    if (
      guard.location.pathname === "/help-center/admin/" ||
      guard.location.pathname === "/help-center/admin"
    ) {
      throw redirect({ to: "/help-center/admin/articles" });
    }
  },
});
